/* eslint-disable no-unused-vars */
import * as _ from 'lodash';
import {
  stepPersonalItemsExpenseLookup,
  stepOverseasMedicalExpenseLookup,
  stepCancellationAdditionalExpenseLookup,
  stepOtherExpenseLookup,
  stepRentalVehicleExpenseLookup,
  stepTripCancellationAndTripInterruptionExpenseLookup,
  stepBaggageAndPersonalItemsExpenseLookup,
  stepMedicalExpensesExpenseLookup,
  stepPetMedicalExpenseLookup,
  stepCollisionDamageExpenseLookup,
  stepPropertyDamageExpenseLookup,
  stepMedicalExpenseLookup,
  stepTripCancellationLookup,
  stepTripInterruptionLookup,
  stepTripDelayLookup,
  stepMissedConnectionLookup,
  stepBaggageAndPersonalLookup,
  stepMedicalExpenseCFLookup,
  baggagePersonalEffectsLookup,
  itineraryChangeLookup,
  stepTravelDelayLookup,
  stepMedicalAndEvacuationLookup,
  stepChangesToYourJourneyLookup,
  stepBaggageAndPersonalItemsSCTILookup,
  stepPersonalAccidentSCTILookup,
  stepRentalVehicleExcessSCTILookup,
  stepCashBankCardsTravelDocumentsAndPassportsLookup,
  stepChangesToYourJourneyTrawickLookup,
  stepBaggageAndPersonalItemsStarrLookup,
  stepOtherStarrLookup,
  stepCollisionDamageStarrLookup,
  stepMedicalExpensesTugoLookup,
  stepOtherTugoLookup,
  stepBaseVictorsMedicalTugoLookup,
} from './claimCodeMapper';
import stepOtherExpenseMapper from './stepOtherDataMapper';
import stepTripCancellationAndTripInterruptionExpenseMapper from './stepTripCancellationAndTripInterruption';
import stepBaggageAndPersonalItemsExpenseMapper from './stepBaggageAndPersonalItemsDataMapper';
import stepMedicalExpensesExpenseMapper from './stepMedicalExpensesDataMapper';
import stepMedicalExpenseMapper from './stepMedicalExpenseDataMapper';
import stepTripCancellationMapper from './stepTripCancellationDataMapper';
import stepTripDelayDataMapper from './stepTripDelayDataMapper';
import stepTripInterruptionDataMapper from './stepTripInterruptionDataMapper';
import stepPetMedicalMapper from './stepPetMedicalDataMapper';
import stepCollisionDamageDataMapper from './stepCollisionDamageDataMapper';
import stepPropertyDamageDataMapper from './stepPropertyDamageDataMapper';
import stepMissedConnectionDataMapper from './stepMissedConnectionDataMapper';
import stepPersonalItemDataMapper from './stepPersonalItemDataMapper';
import stepMedicalExpenseCFDataMapper from './stepMedicalExpenseCFDataMapper';
import stepMedicalExpenseZurichDataMapper from './stepMedicalExpenseZurichDataMapper';
import stepItineraryChangeDataMapper from './stepItineraryChangeDataMapper';
import stepBaggagePersonalEffectsDataMapper from './stepBaggagePersonalEffectsDataMapper';
import stepTravelDelayDataMapper from './stepTravelDelayDataMapper';
import stepMedicalAndEvacuationSCTIDataMapper from './stepMedicalAndEvacuationSCTIDataMapper';
import stepChangesToYourJourneySCTIDataMapper from './stepChangesToYourJourneySCTIDataMapper';
import stepBaggageAndPersonalItemsSCTIDataMapper from './stepBaggageAndPersonalItemsSCTIDataMapper';
import stepCashBankCardsTravelDocumentsAndPassportsDataMapper from './stepCashBankCardsTravelDocumentsAndPassportsDataMapper';
import stepPersonalAccidentSCTIDataMapper from './stepPersonalAccidentSCTIDataMapper';
import stepRentalVehicleExcessSCTIDataMapper from './stepRentalVehicleExcessSCTIDataMapper';
import stepChangesToYourJourneyDataMapper from './stepChangesToYourJourneyDataMapper';
import stepBaggageAndPersonalItemsStarrDataMapper from './stepBaggageAndPersonalItemsStarrDataMapper';
import stepOtherStarrDataMapper from './stepOtherDataStarrMapper';
import stepCollisionDamageStarrDataMapper from './stepCollisionDamageStarrDataMapper';
import stepMedicalExpensesTugoDataMapper from './stepMedicalExpensesTugoDataMapper';
import stepOtherTugoDataMapper from './stepOtherDataTugoMapper';
import stepBaseVictorsMedicalTugoMapper from './stepBaseVictorsMedicalTugoDataMapper';

/**
 * Helper to check if a benefit is selected based on the selectedBenefits list and a lookup's claimCodeList.
 */
function isBenefitSelected(selectedBenefits, lookup) {
  return selectedBenefits.some((d) =>
    lookup.claimCodeList.some((c) => c === d.claimCode)
  );
}

/**
 * Normalise the selectedBenefits from Immutable or plain array.
 */
function normaliseSelectedBenefits(selectedBenefits) {
  return (!!selectedBenefits && typeof selectedBenefits.toJS === 'function')
    ? selectedBenefits.toJS()
    : (selectedBenefits || []);
}

/**
 * Configuration for each benefit mapper.
 * Each entry describes:
 *   - lookup: the claimCodeMapper lookup used to determine if the benefit is selected
 *   - mapper: the data mapper module that has a `mapToExpenses(data)` function
 *   - dataKey: the prop name on the props object that holds the step data
 *   - benefitName: a human-readable name for the benefit
 *   - condition: (optional) extra condition function (props, list) => boolean to override the default selection check
 */
const BENEFIT_CONFIGS = [
  {
    lookup: stepOtherExpenseLookup,
    mapper: stepOtherExpenseMapper,
    dataKey: 'stepOtherData',
    benefitName: 'Other',
  },
  {
    lookup: stepTripCancellationAndTripInterruptionExpenseLookup,
    mapper: stepTripCancellationAndTripInterruptionExpenseMapper,
    dataKey: 'stepTripCancellationAndTripInterruptionData',
    benefitName: 'Trip Cancellation & Trip Interruption',
  },
  {
    lookup: stepBaggageAndPersonalItemsExpenseLookup,
    mapper: stepBaggageAndPersonalItemsExpenseMapper,
    dataKey: 'stepBaggageAndPersonalItemsData',
    benefitName: 'Baggage and Personal Items',
  },
  {
    lookup: stepMedicalExpensesExpenseLookup,
    mapper: stepMedicalExpensesExpenseMapper,
    dataKey: 'stepMedicalExpensesData',
    benefitName: 'Medical Expenses',
    condition: (props) => !props.showZurichUHC,
  },
  {
    lookup: stepCollisionDamageExpenseLookup,
    mapper: stepCollisionDamageDataMapper,
    dataKey: 'stepCollisionDamageData',
    benefitName: 'Collision Damage',
  },
  {
    lookup: stepPetMedicalExpenseLookup,
    mapper: stepPetMedicalMapper,
    dataKey: 'stepPetMedicalData',
    benefitName: 'Pet Medical',
  },
  {
    lookup: stepPropertyDamageExpenseLookup,
    mapper: stepPropertyDamageDataMapper,
    dataKey: 'stepPropertyDamageData',
    benefitName: 'Property Damage',
  },
  {
    lookup: stepTripCancellationLookup,
    mapper: stepTripCancellationMapper,
    dataKey: 'stepTripCancellationData',
    benefitName: 'Trip Cancellation',
  },
  {
    lookup: stepMedicalExpenseLookup,
    mapper: stepMedicalExpenseMapper,
    dataKey: 'stepMedicalExpenseData',
    benefitName: 'Medical Expense',
  },
  {
    lookup: stepTripInterruptionLookup,
    mapper: stepTripInterruptionDataMapper,
    dataKey: 'stepTripInterruptionData',
    benefitName: 'Trip Interruption',
  },
  {
    lookup: stepTripDelayLookup,
    mapper: stepTripDelayDataMapper,
    dataKey: 'stepTripDelayData',
    benefitName: 'Trip Delay',
  },
  {
    lookup: stepMissedConnectionLookup,
    mapper: stepMissedConnectionDataMapper,
    dataKey: 'stepMissedConnectionData',
    benefitName: 'Missed Connection',
  },
  {
    lookup: stepBaggageAndPersonalLookup,
    mapper: stepPersonalItemDataMapper,
    dataKey: 'stepPersonalItemData',
    benefitName: 'Baggage and Personal Effects',
  },
  {
    lookup: stepMedicalExpenseCFLookup,
    mapper: stepMedicalExpenseCFDataMapper,
    dataKey: 'stepMedicalExpenseCFData',
    benefitName: 'Medical Expense (CF)',
  },
  {
    lookup: stepMedicalExpensesExpenseLookup,
    mapper: stepMedicalExpenseZurichDataMapper,
    dataKey: 'stepMedicalExpenseZurichData',
    benefitName: 'Medical Expense (Zurich)',
    condition: (props) => !!props.showZurichUHC,
  },
  {
    lookup: itineraryChangeLookup,
    mapper: stepItineraryChangeDataMapper,
    dataKey: 'stepItineraryChangeData',
    benefitName: 'Itinerary Change',
  },
  {
    lookup: baggagePersonalEffectsLookup,
    mapper: stepBaggagePersonalEffectsDataMapper,
    dataKey: 'stepBaggagePersonalEffectsData',
    benefitName: 'Baggage Personal Effects',
  },
  {
    lookup: stepTravelDelayLookup,
    mapper: stepTravelDelayDataMapper,
    dataKey: 'stepTravelDelayData',
    benefitName: 'Travel Delay & Missed Connections',
  },
  {
    lookup: stepMedicalAndEvacuationLookup,
    mapper: stepMedicalAndEvacuationSCTIDataMapper,
    dataKey: 'stepMedicalAndEvacuationSCTIData',
    benefitName: 'Medical and Evacuation',
  },
  {
    lookup: stepChangesToYourJourneyLookup,
    mapper: stepChangesToYourJourneySCTIDataMapper,
    dataKey: 'stepChangesToYourJourneySCTIData',
    benefitName: 'Changes to your journey (SCTI)',
  },
  {
    lookup: stepBaggageAndPersonalItemsSCTILookup,
    mapper: stepBaggageAndPersonalItemsSCTIDataMapper,
    dataKey: 'stepBaggageAndPersonalItemsSCTIData',
    benefitName: 'Baggage and personal items (SCTI)',
  },
  {
    lookup: stepPersonalAccidentSCTILookup,
    mapper: stepPersonalAccidentSCTIDataMapper,
    dataKey: 'stepPersonalAccidentSCTIData',
    benefitName: 'Personal Accident (SCTI)',
  },
  {
    lookup: stepRentalVehicleExcessSCTILookup,
    mapper: stepRentalVehicleExcessSCTIDataMapper,
    dataKey: 'stepRentalVehicleExcessSCTIData',
    benefitName: 'Rental vehicle excess (SCTI)',
  },
  {
    lookup: stepCashBankCardsTravelDocumentsAndPassportsLookup,
    mapper: stepCashBankCardsTravelDocumentsAndPassportsDataMapper,
    dataKey: 'stepCashBankCardsTravelDocumentsAndPassportsData',
    benefitName: 'Cash, bank cards, travel documents and passports',
  },
  {
    lookup: stepChangesToYourJourneyTrawickLookup,
    mapper: stepChangesToYourJourneyDataMapper,
    dataKey: 'stepChangesToYourJourneyData',
    benefitName: 'Changes to your journey (Trawick)',
  },
  {
    lookup: stepBaggageAndPersonalItemsStarrLookup,
    mapper: stepBaggageAndPersonalItemsStarrDataMapper,
    dataKey: 'stepBaggageAndPersonalItemsStarrData',
    benefitName: 'Baggage and Personal Items (Starr)',
  },
  {
    lookup: stepOtherStarrLookup,
    mapper: stepOtherStarrDataMapper,
    dataKey: 'stepOtherStarrData',
    benefitName: 'Other (Starr)',
  },
  {
    lookup: stepCollisionDamageStarrLookup,
    mapper: stepCollisionDamageStarrDataMapper,
    dataKey: 'stepCollisionDamageStarrData',
    benefitName: 'Collision Damage (Starr)',
  },
  {
    lookup: stepMedicalExpensesTugoLookup,
    mapper: stepMedicalExpensesTugoDataMapper,
    dataKey: 'stepMedicalExpensesTugoData',
    benefitName: 'Medical Expenses (Tugo)',
  },
  {
    lookup: stepOtherTugoLookup,
    mapper: stepOtherTugoDataMapper,
    dataKey: 'stepOtherTugoData',
    benefitName: 'Other (Tugo)',
  },
  {
    lookup: stepBaseVictorsMedicalTugoLookup,
    mapper: stepBaseVictorsMedicalTugoMapper,
    dataKey: 'stepBaseVictorsMedicalTugoData',
    benefitName: 'Medical Expenses (Base Victors Tugo)',
  },
];

/**
 * Gets all expenses for all selected benefits.
 *
 * @param {Object} props - The component props containing step data for all benefits.
 *   Expected keys: stepWhatHappenedData, stepOtherData, stepTripCancellationAndTripInterruptionData,
 *   stepBaggageAndPersonalItemsData, stepMedicalExpensesData, stepCollisionDamageData,
 *   stepPetMedicalData, stepPropertyDamageData, stepTripCancellationData, stepMedicalExpenseData,
 *   stepTripInterruptionData, stepTripDelayData, stepMissedConnectionData, stepPersonalItemData,
 *   stepMedicalExpenseCFData, stepMedicalExpenseZurichData, stepItineraryChangeData,
 *   stepBaggagePersonalEffectsData, stepTravelDelayData, stepMedicalAndEvacuationSCTIData,
 *   stepChangesToYourJourneySCTIData, stepBaggageAndPersonalItemsSCTIData,
 *   stepPersonalAccidentSCTIData, stepRentalVehicleExcessSCTIData,
 *   stepCashBankCardsTravelDocumentsAndPassportsData, stepChangesToYourJourneyData,
 *   stepBaggageAndPersonalItemsStarrData, stepOtherStarrData, stepCollisionDamageStarrData,
 *   stepMedicalExpensesTugoData, stepOtherTugoData, stepBaseVictorsMedicalTugoData,
 *   stepRentalVehicleData, showZurichUHC
 *
 * @returns {Array<Object>} An array of all expense objects from all selected benefits.
 *   Each expense object has the shape: { benefitName, expenses, lookup }
 */
function getAllExpensesForBenefits(props) {
  const { selectedBenefits } = props.stepWhatHappenedData;
  const list = normaliseSelectedBenefits(selectedBenefits);
  const allBenefitExpenses = [];

  // Process each benefit config
  BENEFIT_CONFIGS.forEach((config) => {
    const { lookup, mapper, dataKey, benefitName, condition } = config;
    const isSelected = isBenefitSelected(list, lookup);

    // Skip if benefit is not selected
    if (!isSelected) return;

    // Skip if extra condition is defined and not met
    if (condition && !condition(props)) return;

    const data = props[dataKey];
    if (!data) return;

    const expenses = mapper.mapToExpenses(data);
    if (expenses && expenses.length > 0) {
      allBenefitExpenses.push({
        benefitName,
        expenses,
        lookup,
      });
    }
  });

  // Handle Rental Vehicle separately (it does not use a mapper with mapToExpenses pattern)
  const isStepRentalVehicleSelected = isBenefitSelected(list, stepRentalVehicleExpenseLookup);
  if (isStepRentalVehicleSelected && props.stepRentalVehicleData) {
    const rentalData = props.stepRentalVehicleData;
    const amountClaimed = rentalData.amountClaimed ? +rentalData.amountClaimed : 0;
    if (amountClaimed > 0) {
      allBenefitExpenses.push({
        benefitName: 'Rental Vehicle',
        expenses: [{
          shortDescription: rentalData.description,
          clientCost: amountClaimed,
          currency: rentalData.amountClaimedCurrency,
        }],
        lookup: stepRentalVehicleExpenseLookup,
      });
    }
  }

  return allBenefitExpenses;
}

/**
 * Gets a flat list of all expenses with benefit name tagged on each expense.
 *
 * @param {Object} props - Same props object as getAllExpensesForBenefits.
 * @returns {Array<Object>} A flat array of all expenses, each enriched with a `benefitName` property.
 */
function getAllExpensesFlat(props) {
  const benefitExpenses = getAllExpensesForBenefits(props);
  const flatExpenses = [];

  benefitExpenses.forEach(({ benefitName, expenses }) => {
    expenses.forEach((expense) => {
      flatExpenses.push({
        ...expense,
        benefitName,
      });
    });
  });

  return flatExpenses;
}

/**
 * Gets the total amount claimed across all selected benefits.
 *
 * @param {Object} props - Same props object as getAllExpensesForBenefits.
 * @returns {number} The total sum of clientCost across all expenses.
 */
function getTotalAmountClaimed(props) {
  const flatExpenses = getAllExpensesFlat(props);
  return _.sumBy(flatExpenses, (expense) => +(expense.clientCost || 0));
}

export default {
  getAllExpensesForBenefits,
  getAllExpensesFlat,
  getTotalAmountClaimed,
  isBenefitSelected,
  normaliseSelectedBenefits,
  BENEFIT_CONFIGS,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/dataMapper/allBenefitsExpensesDataMapper.js